<div *ngIf="!hasPermissions">
  <span (click)="open()" class="pointer">
    <span
      [matTooltip]="
        'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.PERMISSIONS_MISSING_SUMMARY'
          | translate
      "
      class="tooltip-anchor"
    >
      {{
        'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.PERMISSIONS_MISSING_CELL'
          | translate
      }}
    </span>
    <button
      mat-icon-button
      (click)="open()"
      cdkOverlayOrigin
      #popoverOrigin="cdkOverlayOrigin"
    >
      <mat-icon class="error-icon">error</mat-icon>
    </button>
  </span>
  <glxy-popover
    [isOpen]="isOpen"
    [origin]="popoverOrigin"
    [hasBackdrop]="true"
    [showBackdrop]="true"
    (backdropClick)="close()"
    [hasArrow]="true"
  >
    <glxy-popover-title>
      {{
        'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.PERMISSIONS_MISSING_TITLE'
          | translate
      }}
    </glxy-popover-title>
    <div>
      <p>
        {{
          'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.PERMISSIONS_MISSING_SUMMARY'
            | translate
        }}
      </p>
      <p>
        {{
          'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.PERMISSIONS_MISSING_BODY'
            | translate
        }}:
      </p>
      <ul>
        <li>
          {{
            'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.PERMISSIONS_MISSING_ROLES'
              | translate
          }}
        </li>
        <li>
          {{
            'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.PERMISSIONS_MISSING_TASKS'
              | translate
          }}
        </li>
      </ul>
      <p>
        <a
          href="https://www.facebook.com/business/help/299504287548592?id=180505742745347"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{
            'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.PERMISSIONS_MISSING_LINK1'
              | translate
          }}
        </a>
      </p>
      <p>
        <a
          href="https://www.facebook.com/business/help/442345745885606?id=180505742745347"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{
            'LEAD_INTEGRATIONS.FACEBOOK.PAGE_PICKER.PERMISSIONS_MISSING_LINK2'
              | translate
          }}
        </a>
      </p>
    </div>
  </glxy-popover>
</div>
